<template>
    <v-layout>
        <v-card style="width: 100%">
            <v-form @submit.prevent="handleRegister" v-if="success">
                <v-container>
                    <v-layout row wrap>
                        <v-flex xs12 xl10 offset-xl2>
                            <h1>Complete Registration</h1>
                            <p>Please use the form below to complete your registration.</p>
                            <p><strong>All fields are required</strong></p>
                        </v-flex>
                        <v-flex xs12 sm6 xl4 offset-xl2>
                            <v-text-field
                                v-model.trim="userInfo.email"
                                label="Email"
                                required
                                disabled
                                clearable
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 xl4>
                            <v-text-field
                                v-model.trim="userInfo.username"
                                required
                                label="Username"
                                clearable
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 xl4 offset-xl2>
                            <v-text-field
                                v-model.trim="userInfo.firstName"
                                required
                                label="First Name"
                                clearable
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 xl4>
                            <v-text-field
                                v-model.trim="userInfo.lastName"
                                required
                                label="Last Name"
                                clearable
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 xl4 offset-xl2>
                            <v-text-field
                                v-model.trim="userInfo.password"
                                required
                                :rules="passwordRules"
                                label="Password"
                                type="password"
                                clearable
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 xl4>
                            <v-text-field
                                v-model.trim="userInfo.passwordConfirm"
                                required
                                :rules="passwordConfirmRules"
                                label="Confirm Password"
                                type="password"
                                clearable
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 xl10 offset-xl2>
                            <v-btn color="primary" class="ml-0" type="submit">Register</v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
            <v-container v-if="error">
                <h1>Uh oh!</h1>
                <p>We couldn't find a user with that registration token. Your token may have expired, or the
                    token may be invalid. Please contact support for assistance.</p>
            </v-container>
        </v-card>
    </v-layout>
</template>

<script>
import FormRules from "@/helpers/form-rules";

export default {
    data() {
        return {
            loading: true,
            error: null,
            registerError: false,
            registerErrors: {},
            success: null,
            userInfo: {
                email: "",
                username: "",
                password: "",
                passwordConfirm: "",
                firstName: "",
                lastName: "",
            },
            passwordRules: FormRules.password,
            passwordConfirmRules: [
                v => !!v || "Please confirm your password",
                v => v === this.userInfo.password || "Passwords do not match",
            ],
        };
    },

    created() {
        this.$store.dispatch("validateUserRegistrationToken", this.$route.params.token)
            .then(resp => {
                this.userInfo.email = resp.user.email;
                this.success = true;
            })
            .catch(err => {
                this.error = true;
            });
    },

    methods: {
        handleRegister() {
            const payload = {
                email: this.userInfo.email,
                username: this.userInfo.username,
                password: this.userInfo.password,
                password_confirmation: this.userInfo.passwordConfirm,
                firstName: this.userInfo.firstName,
                lastName: this.userInfo.lastName,
                token: this.$route.params.token,
            };

            this.$store.dispatch("completeUserRegistration", payload)
                .then(() => {
                    this.$router.push({
                        name: "login",
                        query: { registerSuccess: true },
                    });
                })
                .catch(err => {
                    // error handled in the store
                });
        },
    },
};
</script>